<script setup lang="ts">

import { reactive, ref } from "vue";
import { useBackButton } from "@app/Components/Utilities";
import { useAppConfiguration } from "@domain/AppConfiguration";
import { ConciergeMessages } from "./Components"; 
import { useViewModel } from "./ConciergeViewModel";
import { useViewModelInstance } from "@app/MyGarage/Types/MyGarageViewModelStore";

import { RoadsideAssistancePanel } from "./Components/RoadsideAssistancePanel";
import { ConciergePanel } from "./Components/ConciergePanel";
import { CarePlanPanel } from "./Components/CarePlanPanel";

useBackButton( true, true );

const app = useAppConfiguration();
const viewModel = await useViewModelInstance();
const model = reactive( useViewModel( viewModel.carePlan.roadsideAssistance.isEnabled ) );
const showConciergeCallButton = ref( viewModel.carePlan.carbucksRewards.isConciergeEnabled );

</script>

<template>

    <div class="tracking-wider dark:bg-gray-900
                w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="pb-4 lg:pb-6 3xl:pb-8
                    bg-gradient-to-b from-gray-900 via-gray-850 to-gray-900">

            <div class="p-6 text-center">
                <h2 class="text-xl 3xl:text-2xl tracking-wider flex gap-2 justify-center items-center">
                    How can we help you?
                </h2>
                <p v-if="viewModel.carePlan.carbucksRewards.isConciergeEnabled"
                   class="text-sm lg:text-base 3xl:text-xl pt-4 opacity-60">
                    The Concierge can help you with all the common tasks of owning a vehicle
                </p>
                <p v-else
                   class="text-sm lg:text-base 3xl:text-xl pt-4 opacity-60">
                    We can help you with all the common tasks of owning a vehicle
                </p>
            </div>   

            <!-- MESSAGES -->
            <ConciergeMessages v-if="viewModel.carePlan.carbucksRewards.isConciergeEnabled" class="-mt-6" />

            <!-- HELP PANELS -->
            <div v-if="app.isGeneric || viewModel.carePlan.isEnabled == false"
                 class="px-4 lg:px-6 3xl:px-8 text-base 3xl:text-xl tracking-wider
                        flex flex-col gap-4 3xl:gap-6">
                <p>
                    To get the most out of your Care Plan you need to connect to a participating Dealership
                </p>
                <!-- <p>We provide a care plan for your vehicle that includes:</p>
                <ul class="pl-4 opacity-80 flex flex-col gap-1">
                    <li class="list-disc pl-2">A live-person concierge to help you with all your vehicle needs</li>
                    <li class="list-disc pl-2">Free 30-point vehicle health checks</li>
                    <li class="list-disc pl-2">Exclusive automotive rewards and offers</li>
                    <li class="list-disc pl-2">A packed lifestyle marketplace with rewards and offers</li>
                </ul> 
                <p>
                    Plus many more benefits!
                </p> -->
                <p>
                    If you have a dealership rewards code, click below to unlock your Care Plan
                </p>

                <Button variant="tonal"
                        to="/my-garage/dealership/change"
                        class="!h-10 lg:!h-12 3xl:!h-14 w-full">
                    <span class="3xl:text-lg">Unlock Rewards</span>
                </Button>
            </div>
            
            <div v-else
                 class="flex flex-col gap-6 px-4 lg:px-6">
            
                <RoadsideAssistancePanel v-if="viewModel.carePlan.roadsideAssistance.isEnabled" 
                                         v-model="model.roadsideAssistanceCategory" /> 

                <ConciergePanel v-if="viewModel.carePlan.carbucksRewards.isConciergeEnabled" 
                                v-model="model.conciergeCategory"
                                :show-call-button="showConciergeCallButton" /> 

                <CarePlanPanel v-if="viewModel.carePlan.isEnabled" />

            </div>

        </div>

    </div>

</template>